import React, { useState, useEffect } from "react";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Container, Row } from "react-bootstrap";
import { BASE_URL } from "../../http/urls";
// import faq from "../../assets/videos/vidergraphy.mp4";
// import faq from "../../assets/videos/REV Website.mp4";
import faq from "../../assets/videos/REV Website Comp.mp4";

import Footer from "../../components/footer";
export const VideoandPhotography = () => {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [addOns, setAddOns] = useState([]);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/v1/getevent?shootType=both`);
        setEventData(response.data.data.events);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch event data");
        setLoading(false);
      }
    };

    fetchEventData();
  }, []);

 useEffect(() => {
  const fetchAddOns = async () => {
    try {
      const response = await axios.get(`${BASE_URL}api/v1/listAdd?shootType=both`);
      console.log("AddOns API response:", response.data.data.events); 
      setAddOns(response.data.data.events);
    } catch (error) {
      console.error("Failed to fetch addOns:", error);
      setAddOns([]);
    }
  };
  fetchAddOns();
}, []);
 const leftColumnAddOns = addOns.slice(0, Math.ceil(addOns.length / 2));
  const rightColumnAddOns = addOns.slice(Math.ceil(addOns.length / 2));

  // const addOns = [
  //   { name: "Next Day Edit (Signature)", price: "$1500" },
  //   { name: "Next Day Edit (Classic)", price: "$850" },
  //   { name: "Feature Film (2-3 hours)", price: "$1200" },
  //   { name: "Highlight (Reception added to the NDE)", price: "$350" },
  //   { name: "Instagram Reel", price: "$250" },
  //   { name: "Baby Slideshow", price: "$250" },
  //   { name: "Bride Family Interview", price: "$650" },
  //   { name: "Groom Family Interviews", price: "$650" },
  //   { name: "Pre-Reception Shoot", price: "$500" },
  //   { name: "Next Day Wedding Highlights Slideshow", price: "$250" },
  //   { name: "Canvas size 16x24", price: "$120" },
  //   { name: "Canvas size 24x36", price: "$160" },
  // ];

  // const deliverables = [
  //   "High-Resolution digitals in an online gallery link",
  //   "Long Documentary Edit for Pre-wedding events",
  //   "Long Documentary Edit for Wedding",
  //   "Long Documentary Edit for Reception",
  //   "Drone",
  // ];
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Investment | {meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <div className="videophoto">
        <video
          src={faq}
          autoPlay
          loop
          muted
          className="vid"
          style={{
            width: "100%",
            objectFit: "cover",
            zIndex: "-1",
            top: 0,
            height: "100vh",
          }}
        ></video>
      </div>
      <Container style={{ marginTop: "70px" }}>
        <Row
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "30px",
          }}
          className="for-space-only"
        >
          <h2 className="faq">Photography and Videography Package</h2>
        </Row>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="test-container ">
            <div>
              <p>
                At Made In Heaven, we understand that every moment of your
                wedding journey is worth preserving. Our combined photography
                and videography package offers you the flexibility to choose the
                perfect amount of coverage for each event, no matter the size or
                significance. We’re here to capture all the pre-wedding events
                you want, ensuring every memory is beautifully documented with
                both stunning visuals and cinematic storytelling. This package
                includes options for 2-hour and 3-hour pre-wedding events, each
                priced as shown below. For additional coverage, we offer an
                extended hourly rate of $600/hour, giving you the freedom to
                ensure every important moment is captured without interruption
              </p>
            </div>
          </div>
          {loading && <p>Loading events...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {!loading && !error && eventData && eventData.length > 0 && (
            <div
              className="mt-3 table-container"
              style={{
                width: "70%",
                borderRadius: "15px",
                overflow: "hidden",
                border: "1px solid #dee2e6",
              }}
            >
              <div
                className="table-header"
                style={{
                  display: "flex",
                  backgroundColor: "#f8f9fa",
                  fontWeight: "bold",
                }}
              >
                <div
                  className="table-cell"
                  style={{
                    flex: 2,
                    padding: "10px",
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  Event Name
                </div>
                <div
                  className="table-cell"
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  Hours
                </div>
                <div
                  className="table-cell"
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  photo price
                </div>
                <div
                  className="table-cell"
                  style={{ flex: 1, padding: "10px" }}
                >
                  video price
                </div>
              </div>
              {eventData.map((event, idx) => (
                <div
                  className="table-row"
                  key={event._id || idx}
                  style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
                >
                  <div
                    className="table-cell"
                    style={{
                      flex: 2,
                      padding: "10px",
                      borderRight: "1px solid #dee2e6",
                    }}
                  >
                    {event.name || "N/A"}
                  </div>
                  <div
                    className="table-cell"
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRight: "1px solid #dee2e6",
                    }}
                  >
                    {event.hours || "N/A"}
                  </div>
                  <div
                    className="table-cell"
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRight: "1px solid #dee2e6",
                    }}
                  >
                    ${event.photoPrice || "N/A"}
                  </div>
                  <div
                    className="table-cell"
                    style={{ flex: 1, padding: "10px" }}
                  >
                    ${event.videoPrice || "N/A"}
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* <div
            className="mt-3 table-container"
            style={{
              width: "70%",
              borderRadius: "15px",
              overflow: "hidden",
              border: "1px solid #dee2e6",
            }}
          >
            <div
              className="table-header"
              style={{
                display: "flex",
                backgroundColor: "#f8f9fa",
                fontWeight: "bold",
              }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Event
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px",borderRight: "1px solid #dee2e6", }}>
                Photo Price
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                Video Price
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Each Pre-wedding events (Mehndi, Churra, etc)
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                2 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", borderRight: "1px solid #dee2e6", }}>
                $500
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", }}>
                $800
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Pre-wedding events (Sangeet, Jaggo etc)
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                3 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", borderRight: "1px solid #dee2e6", }}>
                $1000
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", }}>
                $1200
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Wedding Ceremony
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                12 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", borderRight: "1px solid #dee2e6", }}>
                $4000
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", }}>
                $6500
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Reception
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                5 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", borderRight: "1px solid #dee2e6", }}>
                $2000
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", }}>
                $2500
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Engagement
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                4 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", borderRight: "1px solid #dee2e6", }}>
                $1000
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px", }}>
                $1500
              </div>
            </div>
          </div> 
         </div> 
         <div>
          <div className="deliverables mt-3 mb-3 " style={{ lineHeight: "1", fontFamily:"Crimson Text, serif" }}>
            <h4
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textTransform: "uppercase",
                marginBottom: "20px",
              }}
            >
              Deliverables
            </h4>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              High-Resolution digitals in an online gallery link
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Long Documentary Edit for Pre-wedding events
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Long Documentary Edit for Wedding
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Long Documentary Edit for Reception
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Drone for Wedding Day
            </p>
          </div>

          <div className="add-ons" style={{ marginTop: "25px", textTransform: "uppercase" }}>
            <h4
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Add Ons:
            </h4>
            <div className="final" style={{display:"flex", justifyContent:"space-between", fontFamily:"Crimson Text, serif"}}>
            <div
              className="add-ons-list"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "10px",
              }}
            >
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Next Day Edit (Signature) – $1500
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Next Day Edit (Classic) - $850
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Pre-shoot: $1500 (One Instagram Reel + Photos)
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Feature Film (2-3 hours): $1200
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Highlight (Reception added to the NDE): $350
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Next Day Wedding Highlights Slideshow: $250
              </div>
              </div>
              <div className="add-ons-list"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Highlight (Reception added to the NDE): $350
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Instagram Reel - $250
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Baby Slideshow - $250
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Bride & Groom Family Interview - $1200
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Pre-Reception Shoot: $500
              </div>
               <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }} 
              >
                Next Day Wedding Highlights Slideshow: $250
              </div> 
             <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
              >
                Canvas size 16x24: $120
              </div>
              <div
                className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }} 
                 Canvas size 24x36: $160
          </div></div>
        </div>) */}
          <div
            className="deliverables mt-3 mb-3 "
            style={{ lineHeight: "1", fontFamily: "Crimson Text, serif" }}
          >
            <h4
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textTransform: "uppercase",
                marginBottom: "20px",
              }}
            >
              Deliverables
            </h4>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              High-Resolution digitals in an online gallery link
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Long Documentary Edit for Pre-wedding events
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Long Documentary Edit for Wedding
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Long Documentary Edit for Reception
            </p>
            <p
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            ></p>
          </div>
          <div
            className="add-ons"
            style={{ marginTop: "25px", textTransform: "uppercase", width: "100%" }}
          >
            <h4
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              Add Ons:
            </h4>
            {/* Conditional rendering for add-ons */}
            {addOns.length === 0 ? (
              <p style={{ textAlign: "center" }}>No add-ons available or loading...</p>
            ) : (
              <div
                className="final"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontFamily: "Crimson Text, serif",
                  flexWrap: "wrap", // Allow wrapping on smaller screens if needed
                }}
              >
                <div className="add-ons-list-right" style={{ textAlign: "left", flex: 1, minWidth: "300px", marginRight: "20px" }}>
                  {leftColumnAddOns.map((addon, idx) => (
                    <div className="add-on-item" key={addon._id || idx} style={{ marginBottom: "5px" }}>
                      {/* Assuming your API returns 'name' and 'price' for add-ons */}
                      {addon.title}: ${addon.price}
                    </div>
                  ))}
                </div>
                <div className="add-ons-list-left" style={{ textAlign: "left", flex: 1, minWidth: "300px", marginRight: "-200px" }}>
                  {rightColumnAddOns.map((addon, idx) => (
                    <div className="add-on-item" key={addon._id || idx} style={{ marginBottom: "5px" }}>
                      {/* Assuming your API returns 'name' and 'price' for add-ons */}
                      {addon.title}: ${addon.price}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className="description"
          style={{ marginTop: "20px", marginBottom: "70px" }}
        >
          <p>
            Let us create a personalized photography and videography package
            that reflects your vision, allowing you to relive the essence of
            your wedding journey in timeless images and films that celebrate
            your unique story.
          </p>
        </div>
      </Container>

      <Footer />
    </HelmetProvider>
  );
};

export default VideoandPhotography;
